import styled from 'styled-components';
import { getPaletteColor, themeGet } from '@magalu/stereo-ui-styles';
import Box from '../../atoms/Box';
import TextElem from '../../atoms/Text';
export const ListOptions = styled(Box)`
  display: flex;
  height: 40px;
  justify-content: space-around;
  box-shadow: -1px 2px 4px 0 rgba(0, 0, 0, 0.14);
  font-size: ${props => themeGet('fontSizes.1')(props)}px;
  font-weight: ${props => themeGet('fontWeights.medium')(props)};
  background-color: ${props => getPaletteColor('background.base')(props)};
  color: ${props => getPaletteColor('text.scratched')(props)};

  > div {
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;
    border-left: 1px solid ${props => themeGet('colors.whisper')(props)};
  }

  > div:first-child {
    border-left-style: none;
  }
`;
export const Text = styled(TextElem).attrs(props => ({
  color: getPaletteColor('text.scratched')(props)
}))``;